var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeezer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7749 12.844V12.333H14.1759V13.356H9.7749V12.844ZM9.7749 11.207V10.695H14.1759V11.718H9.7749V11.207ZM9.7749 9.569V9.058H14.1759V10.081H9.7749V9.569ZM9.7749 7.88V7.368H14.1759V8.443H9.7749V7.88Z",
    fill: "#F7BACF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82495 17.757V17.245H14.124V18.269H9.82495V17.757ZM9.82495 16.068V15.557H14.124V16.58H9.82495V16.068ZM9.82495 14.431V13.919H14.124V14.942H9.82495V14.431Z",
    fill: "#FE3F80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 12.333H9.7749V12.844V13.356H11.9999V12.333ZM11.9999 10.695H9.7749V11.207V11.719H11.9999V10.695ZM11.9999 9.058H9.7749V9.57V10.082H11.9999V9.058ZM11.9999 7.368H9.7749V7.88V8.443H11.9999V7.368Z",
    fill: "#D7A2B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.245H9.82495V17.757V18.269H12V17.245ZM12 15.557H9.82495V16.068V16.58H12V15.557ZM12 13.919H9.82495V14.431V14.942H12V13.919Z",
    fill: "#DD376F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91211 17.757V17.245H9.21111V18.268H4.91211V17.757ZM4.91211 16.069V15.557H9.21111V16.58H4.91211V16.069ZM4.91211 14.431V13.919H9.21111V14.942H4.91211V14.431Z",
    fill: "#FEEA3A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08811 17.245H4.91211V17.757V18.269H7.08811V17.245ZM7.08811 15.557H4.91211V16.069V16.581H7.08811V15.557ZM7.08811 13.919H4.91211V14.431V14.943H7.08811V13.919Z",
    fill: "#DDCC32"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.844V12.332H4.299V13.356H0V12.844ZM0 11.207V10.695H4.299V11.719H0V11.207Z",
    fill: "#FE9D7F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.757V17.245H4.299V18.268H0V17.757ZM0 16.068V15.556H4.299V16.58H0V16.068ZM0 14.431V13.919H4.299V14.943H0V14.431Z",
    fill: "#FE3D02"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.149 12.332H0V12.844V13.356H2.15V12.332H2.149ZM2.149 10.695H0V11.207V11.719H2.15V10.695H2.149Z",
    fill: "#DD896F"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M2.149 17.245H0V17.757V18.269H2.15V17.245H2.149ZM2.149 15.557H0V16.069V16.581H2.15V15.557H2.149ZM2.149 13.919H0V14.431V14.943H2.15V13.919H2.149Z",
    fill: "#DD3502"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M14.686 12.844V12.332H19.088V13.355H14.686V12.844ZM14.686 11.207V10.695H19.088V11.719H14.686V11.207Z",
    fill: "#E7EE9F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7371 17.757V17.246H19.0361V18.269H14.7371V17.757ZM14.7371 16.068V15.556H19.0361V16.58H14.7371V16.068ZM14.7371 14.431V13.919H19.0361V14.943H14.7371V14.431Z",
    fill: "#CCDB38"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.912 12.333H14.686V12.845V13.356H16.912V12.333ZM16.912 10.695H14.686V11.207V11.719H16.912V10.695Z",
    fill: "#C9CF8A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9121 17.245H14.7371V17.756V18.268H16.9121V17.245ZM16.9121 15.556H14.7371V16.068V16.58H16.9121V15.556ZM16.9121 13.919H14.7371V14.431V14.943H16.9121V13.919Z",
    fill: "#B2BF31"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5991 12.844V12.332H24.0001V13.355H19.5991V12.844ZM19.5991 11.207V10.695H24.0001V11.718H19.5991V11.207ZM19.5991 9.569V9.057H24.0001V10.08H19.5991V9.569ZM19.5991 7.88V7.369H24.0001V8.443H19.5991V7.88ZM19.5991 6.294V5.731H24.0001V6.857H19.5991V6.294Z",
    fill: "#B1E3FA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6499 17.757V17.245H23.9489V18.268H19.6499V17.757ZM19.6499 16.068V15.556H23.9489V16.58H19.6499V16.068ZM19.6499 14.431V13.919H23.9489V14.942H19.6499V14.431Z",
    fill: "#4EC2F6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7991 12.333H19.5991V12.845V13.357H21.7991V12.333ZM21.7991 10.695H19.5991V11.207V11.719H21.7991V10.695ZM21.7991 9.057H19.5991V9.569V10.081H21.7991V9.057ZM21.7991 7.369H19.5991V7.88V8.443H21.7991V7.369ZM21.7991 5.731H19.5991V6.294V6.857H21.7991V5.731Z",
    fill: "#9AC6DA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7989 17.245H19.6499V17.757V18.269H21.7989V17.245ZM21.7989 15.557H19.6499V16.069V16.581H21.7989V15.557ZM21.7989 13.919H19.6499V14.431V14.943H21.7989V13.919Z",
    fill: "#44A9D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeezer);
export default __webpack_public_path__ + "static/media/deezer.17c8dc97.svg";
export { ForwardRef as ReactComponent };